import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch, Redirect, useHistory } from 'react-router-dom';
import ReactGA from 'react-ga';
import { PopUpMessages, Notification, PokerFrameList } from '../components';
import { MainDialog } from '../components/Dialogs';
import { checkAuthentication } from "../store/actionCreators/authentication";
import RouteWithLayout from './RouteWithLayout';
import ForceFullScreen from './FullScreen';
import { Pages, Layouts } from './Views';
import { paths } from './Paths';
import { getAuthenticationStatus } from "../store/selectors";
import { changeLanguage } from '../store/actionCreators/profileSettings';
import config from '../config/config';
import settings from '../config/settings';

const Routes = () => {
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(getAuthenticationStatus);
    const history = useHistory();

    useEffect(function initGoogleAnalyticsHistory() {
        const { googleAnalytics } = config;
        if (!googleAnalytics) return;

        const unlisten = history.listen(location => {
            const path = location.pathname + location.search;
            ReactGA.set({ page: path });
            ReactGA.pageview(path);
        });

        return unlisten;
    }, []);

    const authCheck = () => {
        if (localStorage.authenticationData) {
            dispatch(checkAuthentication());
        }
    };

    const selectedLanguage = useSelector(state => state.selectedLanguage);



    useEffect(() => {
      authCheck();
      if (!localStorage.language) {
        localStorage.setItem('language', settings.languages[0]);
      }
      dispatch(changeLanguage(localStorage.language));
    }, []);

    return (
        <div className="App">
            <ForceFullScreen />
            {
                isAuthenticated ? (
                    <React.Fragment>
                        <Switch>
                            <Redirect
                                exact
                                from="/"
                                to={`/home`}
                            />
                            {
                                paths.authorized.map((path, index) => (
                                    <RouteWithLayout
                                        key={index}
                                        component={Pages[path.view]}
                                        exact
                                        layout={Layouts[path.layout]}
                                        path={path.route}
                                    />
                                ))
                            }
                            <Redirect to={`/home`} />
                        </Switch>
                        <MainDialog />
                        {/* <div id="orientation_dialog"></div> */}
                    </React.Fragment>
                ) :
                    <React.Fragment>
                        <Switch>
                            <Redirect
                                exact
                                from="/"
                                to={`/login`}
                            />
                            {
                                paths.nonAuthorized.map((path, index) => (
                                    <RouteWithLayout
                                        key={index}
                                        component={Pages[path.view]}
                                        exact
                                        layout={Layouts[path.layout]}
                                        path={path.route}
                                    />
                                ))
                            }
                            <Redirect to={`/login`} />
                        </Switch>
                    </React.Fragment>
            }
            <PopUpMessages />
            <Notification />
            <PokerFrameList />
        </div>
    );
};

export default Routes;
